import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import collaboratorTaskAPI from '@infrastructure/collaborator-task-api';
export const createCollaboratorTaskAsync = createAsyncThunk('collaboratorTask/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorTaskAPI.createCollaboratorTask(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateCollaboratorTaskAsync = createAsyncThunk('collaboratorTask/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await collaboratorTaskAPI.updateCollaboratorTask(payload.id, payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getCollaboratorTaskByIdAsync = createAsyncThunk('collaboratorTask/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorTaskAPI.getCollaboratorTaskById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllCollaboratorTasksAsync = createAsyncThunk('collaboratorTask/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await collaboratorTaskAPI.getAllCollaboratorTasks();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteCollaboratorTaskAsync = createAsyncThunk('collaboratorTask/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await collaboratorTaskAPI.deleteCollaboratorTask(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
